<template>
    <v-container fill-height fluid grid-list-xl class="pt-0">
        <v-flex md12>
            <material-card
                color="green"
                :title="
                    'Menu Summary Family Report (' + menuSummary.length + ')'
                "
                class="grid-card"
            >
                <vue-good-table
                    class="pt-0 mb-3"
                    style="cursor: pointer; height: 850px !important;"
                    ref="table"
                    :columns="columns"
                    :rows="menuSummary"
                    @on-row-click="goToAccount"
                    :search-options="{
                        enabled: false,
                    }"
                    v-bind:selectOptions="{
                        enabled: true,
                        selectOnCheckboxOnly: true,
                        selectionText: 'rows selected',
                        clearSelectionText: 'Clear',
                    }"
                >
                    <div
                        slot="table-actions"
                        style="display: flex; flex-flow: row;"
                        class="action_buttons"
                    >
                        <v-btn
                            v-if="getSelectedRows().length"
                            v-on:click="openDownloadReport"
                            class="mx-2"
                            small
                            color="success"
                            style="height: 28px; margin-top: 22px;"
                        >
                            Download Report
                        </v-btn>
                        <v-select
                            style="min-width: fit-content;"
                            class="mr-2 pb-2 pt-3"
                            v-bind:class="{
                                'mt-0': sitesFilter,
                                'mt-2': !sitesFilter,
                            }"
                            label="Sites"
                            multiple
                            @change="loadData"
                            :items="sites"
                            v-model="sitesFilter"
                            hide-details
                        >
                            <template v-slot:selection="{ item, index }">
                                <v-chip v-if="index === 0">
                                    <span>{{ item }}</span>
                                </v-chip>
                                <span
                                    v-if="index === 1"
                                    class="grey--text caption"
                                    >(+{{
                                        sitesFilter.length - 1
                                    }}
                                    others)</span
                                >
                            </template>
                        </v-select>
                        <v-select
                            style="min-width: fit-content; padding-top: 20px !important;"
                            class="mr-2 pb-2"
                            label="Distribution"
                            @change="distributionChanged"
                            :items="distributions.map((d) => d.week)"
                            v-model="distributionName"
                            hide-details
                        ></v-select>
                        <v-spacer></v-spacer>
                        <download-excel
                            :fields="exportFields()"
                            :name="getExportFileName()"
                            :before-generate="() => (isExporting = true)"
                            :before-finish="() => (isExporting = false)"
                            :fetch="exportToExcel"
                            type="xls"
                        >
                            <v-btn
                                small
                                icon
                                :loading="isExporting"
                                class="mt-3"
                                ><v-icon color="success"
                                    >mdi-file-export</v-icon
                                ></v-btn
                            >
                        </download-excel>
                    </div>
                    <template slot="table-header-row" slot-scope="props">
                        <div
                            v-bind:style="
                                `min-width: ${getColumnWidth(
                                    props.column.field,
                                )}px !important`
                            "
                            style="width: 270px;"
                        >
                            <span>
                                {{ props.formattedRow[props.column.field] }}
                            </span>
                        </div>
                    </template>
                    <template slot="table-row" slot-scope="props">
                        <div
                            class="font-weight-regular"
                            style="width: 270px;"
                            v-bind:style="
                                `min-width: ${getColumnWidth(
                                    props.column.field,
                                )}px`
                            "
                        >
                            <span v-if="props.column.field == 'familyID'">
                                <router-link
                                    :to="{
                                        name: 'YkCampFamilyView',
                                        params: {
                                            id: props.row[props.column.field],
                                        },
                                        query: {
                                            distributionID: distributionID,
                                        },
                                    }"
                                    >{{
                                        props.row[props.column.field]
                                    }}</router-link
                                >
                            </span>

                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}
                            </span>
                        </div>
                    </template>
                </vue-good-table>
            </material-card>
        </v-flex>

        <v-dialog v-model="printLabelsDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline pl-3">Print Labels</v-card-title>
                <v-select
                    label="Label Type"
                    class="px-3"
                    v-model="labelType"
                    :items="['8x11', '4x6']"
                >
                </v-select>
                <v-select
                    label="Menu Type"
                    class="px-3"
                    v-model="menuType"
                    :items="['FULL MENU']"
                >
                </v-select>
                <v-select
                    label="Language"
                    class="px-3"
                    v-model="language"
                    :items="['ENGLISH/SPANISH', 'ENGLISH/YIDDISH']"
                >
                </v-select>
                <v-select
                    class="px-3"
                    v-model="distributionName"
                    label="Distribution"
                    :items="distributions.map((d) => d.week)"
                ></v-select>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="printLabelsDialog = false"
                        color="default"
                        dark
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="printLabels"
                    >
                        print
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import {
    pluralize,
    sum,
    formatCurrency,
    groupBy,
    onlyUnique,
} from "../../utils/helpers.js";
import moment from "moment";

export default {
    data: () => ({
        menuSummary: [],
        regID: "",
        isExporting: false,
        processing: false,
        distributions: [],
        distributionID: "",
        distributionName: "",
        campInfo: [],
        sites: [],
        sitesFilter: [],
        groupBySite: false,
        printLabelsDialog: false,
        labelType: "8x11",
        menuType: "FULL MENU",
        language: "ENGLISH/SPANISH",

        columns: [],
    }),
    watch: {},
    async created() {
        await this.loadDistributions();

        await this.loadCampInfo();

        this.loadData();
    },
    methods: {
        async loadData() {
            this.columns = [
                {
                    sortable: true,
                    label: "Family ID",
                    field: "familyID",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: true,
                    label: "Name",
                    field: "nameY",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: true,
                    label: "Site",
                    field: "site",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: true,
                    label: "Phone Number",
                    field: "phoneNumber",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: true,
                    label: "Bungalow",
                    field: "bungalow",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: true,
                    label: "Missing Menu Items",
                    field: "missingMenuItems",
                    hidden: false,
                    type: "number",
                    filterOptions: {
                        enabled: true,
                    },
                },
            ];

            const response = await this.$http.get(
                "api/CampDistribution/GetMenuItemsReport?distributionID=" +
                    this.distributionID,
            );

            const group = groupBy(response, "familyID");

            const groupByFamily = Object.keys(group).map((key) => {
                const family = group[key];

                const row = {
                    familyID: key,
                    nameY: family[0].nameY,
                    site: family[0].site,
                    phoneNumber: family[0].phoneNumber,
                    bungalow: family[0].bungalow,
                };

                family.forEach((item) => {
                    row[item.menuItem] = item.count;
                });

                row.missingMenuItems = this.getMissingMenuItemsCount(row);

                return row;
            });

            const fields = groupByFamily
                .map((family) => Object.keys(family).map((k) => k))
                .flat()
                .filter(onlyUnique);

            fields.forEach((key) => {
                if (this.columns.some((c) => c.field == key)) return;

                this.columns.push({
                    sortable: true,
                    label: key,
                    field: key,
                    hidden: false,
                    tdClass: (row) => this.is0Quantity(row, key),
                    filterOptions: {
                        enabled: true,
                    },
                });
            });

            this.menuSummary = groupByFamily;

            // this.menuSummary = this.getBranch()
            //     ? response.filter((r) =>
            //           this.getBranch()
            //               .split(",")
            //               .includes(r.branch)
            //       )
            //     : response;
        },
        openDownloadReport() {
            this.printLabelsDialog = true;
        },
        getDistributionID(name) {
            if (!name) return null;

            return this.distributions.find((d) => d.week == name).id;
        },
        async printLabels() {
            let selected = this.getSelectedRows();

            if (!selected.length) {
                this.$notify({
                    group: "notification",
                    text: "Please Select Families",
                    type: "error",
                });

                return;
            }

            if (!this.distributionName) {
                this.$notify({
                    group: "notification",
                    text: "Please Select Distribution",
                    type: "error",
                });

                return;
            }

            const ids = selected.map((d) => d.familyID);

            try {
                this.processing = true;

                const response = await this.$http({
                    url: "api/campDistribution/printLables",
                    method: "POST",
                    data: {
                        selectedIDs: ids,
                        distributionID: this.getDistributionID(
                            this.distributionName,
                        ),
                        labelType: this.labelType,
                        fullMenu: this.menuType == "FULL MENU",
                        description2Lang:
                            this.language == "ENGLISH/YIDDISH" ? 1 : 0,
                    },
                    responseType: "blob",
                });

                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Labels.pdf");
                document.body.appendChild(link);
                link.click();

                this.processing = false;
            } catch (e) {
                this.processing = false;
            }
        },
        getSelectedRows() {
            if (!this.$refs.table) return [];

            return this.$refs.table.selectedRows;
        },
        getColumnWidth(field) {
            //console.log(field);

            return "300px";
        },
        is0Quantity(row, field) {
            if (
                [
                    "familyID",
                    "nameY",
                    "site",
                    "phoneNumber",
                    "bungalow",
                ].includes(field)
            )
                return;

            return row[field] == 0 ? "zero-qunatity" : "";
        },
        getMissingMenuItemsCount(row) {
            let missingMenuItemsCount = 0;

            Object.keys(row).forEach((key) => {
                if (
                    [
                        "familyID",
                        "nameY",
                        "site",
                        "phoneNumber",
                        "bungalow",
                        "missingMenuItems",
                    ].includes(key)
                )
                    return;

                if (row[key] == 0) {
                    missingMenuItemsCount++;
                }
            });

            return missingMenuItemsCount;
        },
        goToAccount(data) {
            this.$router.push({
                name: "YkCampFamilyView",
                params: {
                    id: data.row.familyID,
                },
                query: {
                    distributionID: this.distributionID,
                },
            });
        },
        async loadCampInfo() {
            this.campInfo = await this.$http.get(
                "api/campDistribution/getCampInfo",
            );

            const branchList = this.getBranch().split(",");

            this.sites = this.getBranch()
                ? this.campInfo
                      .filter((c) => branchList.includes(c.branch))
                      .map((c) => c.campNameEng)
                : this.campInfo.map((c) => c.campNameEng);
            this.sitesFilter = this.getBranch()
                ? this.campInfo
                      .filter((c) => branchList.includes(c.branch))
                      .map((c) => c.campNameEng)
                : [];
        },
        getSitesFilter() {
            const branchList = this.getBranch().split(",");

            if (this.getBranch()) {
                return this.sitesFilter.length
                    ? this.sitesFilter.map((s) => this.getCampID(s)).join(",")
                    : this.campInfo
                          .filter((c) => branchList.includes(c.branch))
                          .map((c) => c.id)
                          .join(",");
            }

            return this.sitesFilter.map((s) => this.getCampID(s)).join(",");
        },
        getCampID(campName) {
            return this.campInfo.find((c) => c.campNameEng == campName).id;
        },
        getBranch() {
            return this.$store.state.authentication.branch &&
                !this.$store.state.authentication.branch.includes("null")
                ? this.$store.state.authentication.branch
                : "";
        },
        async loadDistributions() {
            this.distributions = await this.$http.get(
                "api/campDistribution/getDistributions",
            );

            const last = this.distributions[this.distributions.length - 1];
            this.distributionName = last.week;
            this.distributionID = last.id;
        },
        distributionChanged(value) {
            this.distributionID = this.distributions.find(
                (d) => d.week == value,
            ).id;

            this.loadData();
        },
        getExportFileName() {
            return "Menu Summary - " + moment().format("L");
        },

        exportFields() {
            let fields = {};

            this.columns.forEach((column) => {
                if (column.hidden) return;

                fields[column.label] = column.field;
            });

            return fields;
        },

        async exportToExcel() {
            return this.menuSummary;
        },
    },
};
</script>
<style>
.toggle-button {
    font-size: 15px;
    padding: 5px !important;
}
.toggle-button-group.v-btn-toggle .v-btn.v-btn--active {
    background-color: #dcdfe6;
}
.v-btn__content {
    color: unset;
}
.zero-qunatity {
    background-color: #f17269 !important;
    color: #fff !important;
}
</style>
